import { request } from '@/utils/request'

/**
 * @description 获取资源信息列表
 */
export function getResourceInformations(params: any) {
  return request({
    url: '/resourceinformation/getResourceInformations',
    method: 'get',
    params,
  })
}

/**
 * @description 获取资源详情
 */
export function getResourceDetail(params: any) {
  return request({
    url: '/resourceinformation/getZcjResourceInformation',
    method: 'get',
    params,
  })
}

/**
 * @description 获取拥有资源的企业行业
 */
export function getHadResourceIndustryH5() {
  return request({
    url: '/resourceinformation/getHadResourceIndustryH5',
    method: 'get',
  })
}

/**
 * @description 申请入驻验证
 */
export function applyZcjResourceEnterInformation(params: any) {
  return request({
    url: '/zhongcaijie/h5/resourceEnterInformation/applyZcjResourceEnterInformation',
    method: 'post',
    params,
  })
}

/**
 * @description 获取入驻验证码
 */
export function resourceSendPhoneNumber(params: any) {
  return request({
    url: '/zhongcaijie/h5/resourceEnterInformation/sendPhoneNumber',
    method: 'get',
    params,
  })
}

/**
 * @description 查询资源类型
 */
export function getResourceType(params: any) {
  return request({
    url: '/resourceinformation/getResourceType',
    method: 'get',
    params,
  })
}

/**
 * @description 查询拥有资源的城市
 */
export function getHadResourceCity(params: any) {
  return request({
    url: '/resourceinformation/getHadResourceCity',
    method: 'get',
    params,
  })
}

/**
 * @description 保存中财捷用户对接表
 */
export function saveUserDocking(params: any) {
  return request({
    url: '/zhongcaijie/h5/user/saveUserDocking',
    method: 'post',
    params,
  })
}
